import { render, staticRenderFns } from "./PricingTestimonials.vue?vue&type=template&id=4afe37ba&scoped=true"
import script from "./PricingTestimonials.vue?vue&type=script&lang=js"
export * from "./PricingTestimonials.vue?vue&type=script&lang=js"
import style0 from "./PricingTestimonials.vue?vue&type=style&index=0&id=4afe37ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afe37ba",
  null
  
)

export default component.exports